// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__pLF4x","text":"Toggle_text__3yCyc","track":"Toggle_track__dh7B1","checked":"Toggle_checked__2Xtvz","indicator":"Toggle_indicator__3ppLO"};